// @ts-nocheck

export const MP_CARD_HALO_DURATION = 3500; // ms
